import { siteConfig } from "@/config/siteConfig";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

export const WhyUs = () => (
  <section id="hakkimizda" data-testid="why-us-section" className="scroll-mt-20 bg-paper py-20 md:py-28">
    <div className="mx-auto max-w-6xl px-5">
      <div className="grid gap-12 lg:grid-cols-[1fr_1.6fr] lg:gap-16">
        <div>
          <SectionHeading
            eyebrow="Hakkımızda"
            title="Neden Salihli Oto Çekici?"
            desc="Salihli'de kendi kurtarıcı aracımızla hizmet veriyoruz. Sitede gördüğünüz tüm fotoğraflar, gerçekleştirdiğimiz işlerden karelerdir."
            testid="why-us-heading"
          />
        </div>
        <ul className="grid gap-x-10 gap-y-7 sm:grid-cols-2">
          {siteConfig.whyUs.map((item, i) => {
            const Icon = item.icon;
            return (
              <Reveal key={item.title} delay={i * 0.05}>
                <li className="flex gap-4" data-testid={`why-us-item-${i}`}>
                  <span className="mt-0.5 grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-brand text-white shadow-md shadow-brand/25" aria-hidden="true">
                    <Icon className="h-5 w-5" />
                  </span>
                  <div>
                    <h3 className="font-display text-base font-bold text-ink-900">{item.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-neutral-500">{item.desc}</p>
                  </div>
                </li>
              </Reveal>
            );
          })}
        </ul>
      </div>
    </div>
  </section>
);
